import { MapPin, Phone, Mail, Globe } from "lucide-react";
import BusinessHours from "@/components/BusinessHours";
import { useAppSettings } from "@/lib/appSettings";

export default function Footer({ variant = "app" }) {
  const isApp = variant === "app";
  const s = useAppSettings();
  return (
    <footer
      data-testid="site-footer"
      className={`border-t border-slate-200 ${isApp ? "bg-white" : "bg-transparent"} px-6 md:px-8 lg:px-10 py-5`}
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] font-mono text-slate-600">
        <div className="flex items-center gap-3 flex-wrap">
          <span className="font-display text-[13px] font-black tracking-tight text-red-600" data-testid="footer-company">{s.company_name || "KINOS"}</span>
          <span className="hidden sm:inline text-slate-400">·</span>
          <span className="hidden sm:inline uppercase tracking-[0.2em] text-[9px] text-slate-500">{s.company_tagline || "Leading Innovation Technology"}</span>
          <BusinessHours />
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <a
            href="https://maps.google.com/?q=Rua+Fatuhada+Dili+Timor-Leste"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 hover:text-red-600 transition-colors"
            data-testid="footer-address"
          >
            <MapPin className="h-3 w-3" strokeWidth={1.5} />
            Rua Fatuhada, Dili, Timor-Leste
          </a>
          <a href="tel:+67077138966" className="flex items-center gap-1.5 hover:text-red-600 transition-colors" data-testid="footer-phone">
            <Phone className="h-3 w-3" strokeWidth={1.5} />
            +670 77138966 / 3311480
          </a>
          <a href="mailto:info@kinos.tl" className="flex items-center gap-1.5 hover:text-red-600 transition-colors" data-testid="footer-email">
            <Mail className="h-3 w-3" strokeWidth={1.5} />
            info@kinos.tl
          </a>
          <a href="https://www.kinos.tl" target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:text-red-600 text-slate-700 transition-colors" data-testid="footer-website">
            <Globe className="h-3 w-3" strokeWidth={1.5} />
            www.kinos.tl
          </a>
        </div>
      </div>
    </footer>
  );
}
